import React from "react";
import { Disc3 } from "lucide-react";

const items = [
  "Dragon Fist VR",
  "Monkey Doo",
  "UG",
  "Impulso",
  "Momento Mori",
  "Red Ruby",
  "McGeorge School of Law",
  "AEE",
  "FDE",
  "Memento Mori",
  "Pacific Conservatory",
];

const CreditsMarquee = () => {
  const list = [...items, ...items]; // duplicate for seamless loop
  return (
    <section className="py-10 md:py-14 border-y border-black/10 bg-[#efeae3] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 mb-6 flex items-center justify-between">
        <span className="text-xs uppercase tracking-[0.22em] text-neutral-500">
          As heard in
        </span>
        <span className="text-xs uppercase tracking-[0.22em] text-neutral-500">
          Selected credits
        </span>
      </div>
      <div className="relative">
        <div className="flex gap-12 md:gap-20 marquee-track whitespace-nowrap">
          {list.map((t, i) => (
            <span
              key={i}
              className="inline-flex items-center gap-4 text-3xl md:text-5xl lg:text-6xl tracking-tight font-medium text-black/85"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              {t}
              <Disc3 className="w-5 h-5 md:w-7 md:h-7 text-neutral-400" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CreditsMarquee;
